﻿import { Grid } from "@serenity-is/sleekgrid";

const orgSetFocus = Grid.prototype["setFocus"];


if (orgSetFocus) {
    Grid.prototype["setFocus"] = function () {
        let selection = null;

        if (window.getSelection && window.getSelection().rangeCount > 0) {
            selection = window.getSelection().getRangeAt(0);
        }

        orgSetFocus.apply(this, arguments);

        if (selection && this._options.enableTextSelectionOnCells) {
            const target = window.getSelection();
            target.removeAllRanges();
            target.addRange(selection);
        }
    }
}
